import { number, object, string } from 'yup'

import type {
  CreateObjectDescriptionStepResponse,
  SaveCreateObjectDescriptionRequest,
} from 'shared/api/kyrgyzstan/create-object'
import { createYupFormResolver } from 'shared/lib/form'

export interface CreateObjectDescriptionFormValues {
  title: string
  description: string
  capacity: number
}

export const CREATE_OBJECT_DESCRIPTION_TITLE_MAX_LENGTH = 255
export const CREATE_OBJECT_DESCRIPTION_TEXT_MAX_LENGTH = 256

export const createObjectDescriptionFormDefaultValues: CreateObjectDescriptionFormValues =
  {
    title: '',
    description: '',
    capacity: 0,
  }

const requiredFieldMessage = ''

const createObjectDescriptionFormSchema = object({
  title: string()
    .trim()
    .required(requiredFieldMessage)
    .max(CREATE_OBJECT_DESCRIPTION_TITLE_MAX_LENGTH),
  description: string()
    .trim()
    .required(requiredFieldMessage)
    .max(CREATE_OBJECT_DESCRIPTION_TEXT_MAX_LENGTH),
  capacity: number()
    .required(requiredFieldMessage)
    .min(1, requiredFieldMessage),
})

export const createObjectDescriptionFormResolver =
  createYupFormResolver<CreateObjectDescriptionFormValues>(
    createObjectDescriptionFormSchema,
  )

export const mapCreateObjectDescriptionResponseToFormValues = (
  description: CreateObjectDescriptionStepResponse,
): CreateObjectDescriptionFormValues => ({
  title: description.title,
  description: description.description,
  capacity: description.capacity || 1,
})

export const mapCreateObjectDescriptionFormValuesToRequest = ({
  title,
  description,
  capacity,
}: CreateObjectDescriptionFormValues): SaveCreateObjectDescriptionRequest => ({
  title,
  description,
  guests_count: capacity,
  tag_ids: [],
})
